import { React, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

function ForgetPassword() {
    let [error, setError] = useState('');
    function handleSubmit(e) {
        e.preventDefault();
        const data = new FormData(e.target);
        const postData = {
            email: data.get('email')
        };
        axios.post('https://rechargemoi.ma/backend/api/reset_password', postData, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            const js = res.data;
            if (res.status === 200) {
                alert("تم إرسال رابط استعادة كلمة المرور إلى بريدك الإلكتروني");
            } else {
                setError("الرجاء التحقق من البريد الإلكتروني وإعادة المحاولة");
            }
        }).catch((err) => {
            setError("حدث خطأ أثناء استعادة كلمة المرور");
        });
    }

  return (
    <div className="container">
        <h2 className="mt-5">نسيت كلمة المرور</h2>
        <p>يرجى إدخال بريدك الإلكتروني لاستعادة كلمة المرور.</p>
        {error && <div className="alert alert-danger">{error}</div>}
        <form method="POST" action="/backend/forgot-password" onSubmit={handleSubmit}>
            <div className="input-group mb-3">
                <div className="input-group-prepend">
                    <span className="input-group-text">
                        <FontAwesomeIcon icon={faEnvelope} />
                    </span>
                </div>
                <input 
                    type="email" 
                    className="form-control" 
                    id="email" 
                    name="email" 
                    placeholder="البريد الإلكتروني"
                    required 
                />
            </div>
            <div className="d-grid gap-2">
                <button type="submit" className="btn btn-primary">استعادة كلمة المرور</button>
            </div>
        </form>
    </div>
  );
}

export default ForgetPassword;